module.exports = __webpack_public_path__ + "img/logo-emblem.1ad49091.png";